import { getLabel } from 'containers/RiskAssessmentsDetails/RiskMatrix/styles';

import { RISK_MATRIX_CONSTANTS, RISK_COLORS, RISK_LABELS } from '../constants';

export const generateScores = (mRows: number, mColumns: number): number[][] => {
  if (mRows < RISK_MATRIX_CONSTANTS.MIN_SIZE || mColumns < RISK_MATRIX_CONSTANTS.MIN_SIZE) {
    throw new Error(`Matrix dimensions must be at least ${RISK_MATRIX_CONSTANTS.MIN_SIZE}`);
  }

  if (mRows > RISK_MATRIX_CONSTANTS.MAX_SIZE || mColumns > RISK_MATRIX_CONSTANTS.MAX_SIZE) {
    throw new Error(`Matrix dimensions cannot exceed ${RISK_MATRIX_CONSTANTS.MAX_SIZE}`);
  }

  const scores: number[][] = [];
  for (let i = 0; i < mRows; i += 1) {
    const row: number[] = [];
    for (let j = 0; j < mColumns; j += 1) {
      row.push((mRows - i) * (j + 1));
    }
    scores.push(row);
  }
  return scores;
};

export const getRiskLabel = (bgColor: string): string => {
  const colorMap: Record<string, string> = {
    [RISK_COLORS.LOW]: RISK_LABELS.LOW,
    [RISK_COLORS.LOW_ALT]: RISK_LABELS.LOW,
    [RISK_COLORS.MEDIUM]: RISK_LABELS.MEDIUM,
    [RISK_COLORS.HIGH]: RISK_LABELS.HIGH,
    [RISK_COLORS.VERY_HIGH]: RISK_LABELS.VERY_HIGH,
  };

  return colorMap[bgColor] || RISK_LABELS.EXTREME;
};

// New function to get risk label dynamically based on impact and likelihood
export const getDynamicRiskLabel = (
  impact: number,
  likelihood: number,
  matrixRows?: number,
  matrixColumns?: number
): string => getLabel(impact, likelihood, matrixRows, matrixColumns);

export const calculateRiskScore = (impact: number, likelihood: number): number => impact * likelihood;

export const validateMatrixConfig = (config: {
  rows: number;
  columns: number;
  impactLabels: string[];
  likelihoodLabels: string[];
}): boolean =>
  config.rows >= RISK_MATRIX_CONSTANTS.MIN_SIZE &&
  config.rows <= RISK_MATRIX_CONSTANTS.MAX_SIZE &&
  config.columns >= RISK_MATRIX_CONSTANTS.MIN_SIZE &&
  config.columns <= RISK_MATRIX_CONSTANTS.MAX_SIZE &&
  config.impactLabels.length === config.columns &&
  config.likelihoodLabels.length === config.rows;
